/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Fetch inventory locations
import axios from 'axios';

import { URLHelper } from 'sarsaparilla';

export async function fetchGalleryItems(
    q = null,
    locationID = null,
    winnersOnly = false,
    categories = [],
    activities = [],
    contest = null,
    sort = null,
    start = 0,
    size = 20
) {
    const params = {
        q,
        location: locationID,
        winners: winnersOnly,
        category: categories,
        activity: activities,
        contest,
        sort,
        start,
        size,
    };
    return axios.get(
        URLHelper.urlWithParams(`${process.env.API}/ugc/story/gallery/search`, params)
    );
}

export async function fetchGalleryStory(storyId) {
    const params = {};
    return axios.get(
        URLHelper.urlWithParams(
            `${process.env.API}/ugc/story/gallery/story/${storyId}`,
            params
        )
    );
}

export async function fetchStorySearchLocations(storyLocations) {
    const params = { fq: [] };
    storyLocations.forEach((loc) => {
        params.fq[params.fq.length] = `entity_id:${loc.location_id}`;
    });
    return axios.get(URLHelper.urlWithParams(`${process.env.API}/search`, params));
}
